import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ILoginPayload, ILoginResponseDTO } from '../../../../features/auth/@core/interfaces/login.interface';
import { IUserDTO } from '../../../interfaces';
import { ApiService } from '../../api.service';

@Injectable({
  providedIn: 'root',
})
export class SuperAdminAccountController {
  private readonly _path = '/super-admin/account';

  constructor(private apiService: ApiService) {}

  login(payload: ILoginPayload): Observable<ILoginResponseDTO> {
    return this.apiService.post<ILoginResponseDTO>(`${this._path}/login`, payload);
  }

  getMe(): Observable<IUserDTO> {
    return this.apiService.get(`${this._path}/me`);
  }
}
